import { Injectable } from '@angular/core';
import { Router, CanActivate,   ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    if (this.authService.isAuthenticated()) {
       return true;
    }

    // Retain the attempted URL for redirection
    // this.authService.redirectUrl = state.url;
    // this.router.navigate(['/beta']);

    this.router.navigate(['/login']);
    return false;
  }

}

